export default class EngagementLocationModel {
  value: string;
  label: string;

  constructor(data: any) {
    this.value = data || undefined;
    this.label = data || undefined;
  }
}
